// vendor modules
import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
// internal modules
import { advancedSearchify } from "search-new/searchify/searchify-action-creators"
import Tooltip from "app/static/frontend/components/Tooltip"

export function Searchify(props) {
    const handleAdvancedSearchify = async (event) => {
        event.preventDefault()
        event.stopPropagation()
        await props.onLaunch(event)
        return props.advancedSearchify(props.searchifyConfigs)
    }

    return props.tooltipLabel
        ? (
            <div
                onClick={handleAdvancedSearchify}
                className="is-searchify"
            >
                <Tooltip
                    label={props.tooltipLabel}
                    {...props}
                >
                    {props.children}
                </Tooltip>
            </div>
        )
        : (
            <div
                onClick={handleAdvancedSearchify}
                className="is-searchify"
            >
                {props.children}
            </div>
        )
}

Searchify.propTypes = {
    advancedSearchify: PropTypes.func.isRequired,
    children: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    onLaunch: PropTypes.func,
    searchifyConfigs: PropTypes.object.isRequired,
    tooltipLabel: PropTypes.string,
}

Searchify.defaultProps = {
    disabled: false,
    onLaunch: () => {},
}

export default connect(null, { advancedSearchify })(Searchify)
